module.exports = __webpack_public_path__ + "static/img_8-16f08b28629fa49f84da11c78e1e4e23.png";